// LoadingState.jsx
// Loading state component for EditListing

import React from 'react';
import { styles } from './styles';

// Spinner SVG Icon
const SpinnerIcon = () => (
  <svg 
    width="48" 
    height="48" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2"
    style={styles.spinnerAnimation}
  >
    <path d="M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83" />
  </svg>
);

const LoadingState = () => {
  return (
    <div style={styles.loadingContainer}>
      <div style={styles.loadingContent}>
        <SpinnerIcon />
        <p style={styles.loadingText}>Loading listing details...</p>
        <p style={styles.loadingSubtext}>Please wait while we fetch your listing</p>
      </div>
    </div>
  );
};

export default LoadingState;